import PropTypes from 'prop-types'

import {Map} from 'immutable'

import routerUtils from '../../../../../../lib/routerUtils'

import {Text} from '../../../blocks/Texts'

import './vaultExtension.scss'

const VaultExtension = ({
  firmName,
  logEvent,
  resetSearch,
  userInitial,
  vaultExtension
}) => {
  // Find the package name by looking for the cart item with category "Package"
  const cartItems = vaultExtension.getIn(['data', 'plan', 'cart-items'])
  const packageCartItem = cartItems?.find(item =>
    item.getIn(['line-item', 'category']) === 'Package'
  )
  const packageName = packageCartItem?.getIn(['line-item', 'name']) || 'My Prearrangements'

  const onClick = () => {
    logEvent('clicked_search_result', {type: 'vault_extension'})

    resetSearch()

    routerUtils.push('/cm/category/life-and-legacy?openVaultExtensionModal=true')
  }

  return (
    <div className='flex-container result border-bottom vault-extension-result' onClick={onClick}>
      <div className='profile-circle'>
        {userInitial}
      </div>
      <div className='result-content'>
        <Text className='bold-text'>
          My Prearrangements
        </Text>
        <Text className='package-name link-text'>{packageName}</Text>
        {firmName && <Text className='firm-name'>Provided by {firmName}</Text>}
      </div>
    </div>
  )
}

VaultExtension.propTypes = {
  firmName: PropTypes.string,
  logEvent: PropTypes.func,
  resetSearch: PropTypes.func,
  userInitial: PropTypes.string,
  vaultExtension: PropTypes.instanceOf(Map)
}

export default VaultExtension
